import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';


const ProtectedRoute = ({ children }) => {
//  const navigate = useNavigate();
  const token =  localStorage.getItem('token')

  if (!token) {
  //  navigate('/login'); // Redirigir a login si no hay token o está expirado
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
